import React from 'react';
import { colors } from '../utils/colors';

export type LoadingIndicatorProps = {
  style?: React.CSSProperties;
  text?: string;
  color?: string;
  className?: string;
  isLoading?: boolean;
};

export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  style,
  text,
  color,
  className,
  isLoading = true,
}) => {
  const _text = text ?? 'Loading...';
  if (!isLoading) {
    return null;
  }
  return (
    <div
      style={style}
      className={`d-flex justify-content-center align-content-center ${className}`}
    >
      <div
        className={`spinner-border ${_text?.length > 0 ? 'me-3' : ''}`}
        style={{ color: color ?? colors.primaryBlue }}
        role="status"
      />
      <span className="sr-only">{_text}</span>
    </div>
  );
};
